export default __webpack_public_path__ + "public/images/home/intro/blueStar@2x.png?dc6eeb72";